import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CrudService, CustomHttp, ConfigServerService } from '../../../../core';
import { RegiaoGeograficaIntermediaria } from '../regiao-geografica-intermediaria';
import { RegiaoGeograficaIntermediariaFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class RegiaoGeograficaIntermediariaCrudHttpService {
    resource = 'regiaogeografica/intermediaria';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todas as regiões geográficas intermediárias cadastradas */
    search(): Observable<RegiaoGeograficaIntermediaria[]> {
        return this.crudService.search<RegiaoGeograficaIntermediaria>(this.resource);
    }

    /** Pesquisa todas as regiões geográficas intermediárias cadastradas */
    searchWithFilter(filter: RegiaoGeograficaIntermediariaFilter): Observable<RegiaoGeograficaIntermediaria[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get(this.pathApi, {params});
    }
}
